module.exports = __webpack_public_path__ + "static/img/1A.0373e135.svg";